var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-landing flex center",class:{ column: _vm.vertical }},[_c('div',{staticClass:"com-loading--circular",style:({
      color: _vm.color,
      width: _vm.computedSize,
      height: _vm.computedSize,
    })}),(_vm.$slots.default)?_c('div',{staticClass:"com-loading--text mpm-ml16 mpm-tclr-cont",class:{ 'mpm-pt16': _vm.vertical },style:({
      color: _vm.color,
      fontSize: _vm.computedFontSize,
    })},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }